<template>
  <Modal v-model="visible" :title="formData.id?'编辑':'新增'" width="630" class="my-modal top" :mask-closable="false" :footer-hide="true">
    <Form v-if="visible" ref="form" :model="formData" class="less" :label-width="90" v-loading="loading" style="margin-top:10px;">
      <FormItem prop="picName" label="图片名称" :rules="$units.formRule.required('请输入')" class="full">
        <Input v-model="formData.picName" placeholder="请输入"/>
      </FormItem>
      <FormItem prop="mobilePic" :label-width="100" label="展示图片" :rules="$units.formRule.required('请上传')">
        <uploadNew v-model="formData.imgMobileArr" @change="imgUploadMobile" @remove="$set(formData, 'mobilePic' ,'')"></uploadNew>
        <div class="info-text">建议图片尺寸为:690*120px；最大不超过500KB；仅限上传jpg/jpeg/png格式；</div>
      </FormItem>
      <!-- <FormItem prop="pcPic" label="PC端图片" :rules="$units.formRule.required('请上传')">
        <uploadNew v-model="formData.imgPcArr" @change="imgUploadPc" @remove="$set(formData, 'pcPic' ,'')"></uploadNew>
        <div class="info-text">建议轮播图片尺寸为:1600*200px；最大不超过500KB；仅限上传jpg/jpeg/png格式；</div>
      </FormItem> -->
      <!-- <FormItem prop="jumpType" label="跳转类型" :rules="$units.formRule.required('请选择')">       
        <RadioGroup v-model="formData.jumpType" @on-change="changeJumpType">
          <Radio label="1">链接</Radio>
          <Radio label="2">产品</Radio>
        </RadioGroup>
      </FormItem> -->
      <!-- <FormItem v-if="formData.jumpType=='1'" prop="picTitle" label="内容标题" class="full" key="picTitle1">
        <Input v-model="formData.picTitle" placeholder="请输入"/>
      </FormItem> -->
      <!-- <FormItem v-else prop="picTitle" label="内容标题" :rules="$units.formRule.required( formData.jumpType=='1' ? '请输入' : '请选择' )" class="full" key="picTitle2">
        <span class="product-title" v-if="formData.picTitle">{{ formData.picTitle }}</span>
        <Button type="primary" class="select-product-btn" @click="$refs.selectProduct.open()">{{ formData.picTitle?'重新选择':'选择产品' }}</Button>
      </FormItem> -->
      <FormItem
        prop="jumpUrl"
        label="跳转链接" 
        class="full" 
        :rules="$units.formRule.url()"
      >
        <Input v-model="formData.jumpUrl" placeholder="链接必须以http://或https://开头"/>
      </FormItem>
      <FormItem prop="orderNum" label="排序" :rules="$units.formRule.justIntSort()" class="full">
        <Input v-model="formData.orderNum" placeholder="填写正整数，数字越大排序越前"/>
      </FormItem>
      <FormItem label="有效期" class="full">
        <DatePicker
          :clearable="true"
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          v-model="formData.validDate"
          format="yyyy-MM-dd"
          placeholder="不填就是长期有效"
        >
        </DatePicker>
      </FormItem>
      <FormItem label="展示机构" key="showOrgIds" prop="showOrgIds" class="full" style="margin-bottom:9.5px;" :rules="$units.formRule.required('请选择展示机构',trigger = 'change',type = 'array')">
        <selectTree 
          :selectAllChildren="true"
          v-model="formData.showOrgIds"
          :multiple="true"
          ref="selectTreeRef"
          @getOrgTreeData="getOrgTreeData"
        ></selectTree>
      </FormItem>

      <FormItem label="新建子机构自动设置为展示机构" class="full" :label-width="268">
        <i-switch v-model="formData.isSycn" size="large" true-value="1" false-value="0">
          <span slot="open">是</span>
          <span slot="close">否</span>
        </i-switch>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible=false">取消</Button>
      <Button type="primary" @click="save">确认</Button>
    </div>
    <!-- 选中产品 -->
    <select-product ref="selectProduct" @confirm-select="getSelectProduct"></select-product>
  </Modal>
</template>

<script>
import uploadNew from "@/components/commons/uploadNew";
import selectTree from "./selectTree";
import selectProduct from "./selectProduct";
import filter from "@/api/filter";
export default {
  props:['initBannerList'],
  components:{uploadNew, selectTree, selectProduct},
  data() {
    return {
      filter,
      visible:false,
      loading:false,
      formData:{},
      showOrgIdsArr:[]
    }
  },
  methods:{
    // 默认勾选展示机构
    getOrgTreeData(data) {
      if(!this.formData.id){
        this.$set(this.formData, 'showOrgIds', this.dealTree(data));
      }
    },

    // 得到树结构id，组成新数组
    dealTree(arr) {
      arr.forEach(item => {
        this.showOrgIdsArr.push(item.id);
        if (item.children) {
          this.dealTree(item.children)
        }
      })
      return this.showOrgIdsArr
    },

    save(){
      this.$refs.form.validate().then(isok=>{
        if(!isok){
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        delete formData.imgMobileArr;
        delete formData.imgPcArr;

        let data = {
          ...formData,
          effectTimeStart:formData.validDate&&formData.validDate[0]?this.filter.filterTime(formData.validDate[0], 'YYYY-MM-DD HH:mm:ss'):'',
          effectTimeEnd:formData.validDate&&formData.validDate[1]?this.filter.filterTime(formData.validDate[1], 'YYYY-MM-DD 23:59:59'):'',
          configType:3
        }
        delete data.validDate;
        let editData = {
          configType:3,//配置类型 1、首页轮播 2、弹窗广告
          id:formData.id,
          jumpType:formData.jumpType,
          picName:formData.picName,
          picTitle:formData.picTitle,
          mobilePic:formData.mobilePic,
          pcPic:formData.pcPic,
          orderNum:formData.orderNum,
          productCode:formData.productCode,
          effectTimeStart:formData.validDate&&formData.validDate[0]?this.filter.filterTime(formData.validDate[0], 'YYYY-MM-DD HH:mm:ss'):'',
          effectTimeEnd:formData.validDate&&formData.validDate[1]?this.filter.filterTime(formData.validDate[1], 'YYYY-MM-DD 23:59:59'):'',
          showOrgIds:formData.showOrgIds,
          jumpUrl:formData.jumpUrl,
          isSycn:formData.isSycn
        }
        this.$http({
          url: this.formData.id ? "/buz/exhibitionPicConfig/edit" : "/buz/exhibitionPicConfig/add",
          type: "POST",
          data: this.formData.id ? editData: data,
          apiPermissionCode:'operate_3_1'
        }).then(res=>{
          this.visible = false;
          this.$notice.success(formData.id?"修改成功":"新增成功");
          this.initBannerList();
        })        
      })
    },
    async open(data={}){
      this.showOrgIdsArr = [];
      data = JSON.parse(JSON.stringify(data));
      if(data.id){
        if(data.effectTimeEnd && data.effectTimeStart){
          data.validDate = [data.effectTimeStart,data.effectTimeEnd];
        }
        data.mobilePic = data.mobilePic;
        data.imgMobileArr = [{path:data.mobilePic}];
        data.pcPic = data.pcPic;
        data.imgPcArr = [{path:data.pcPic}];
        this.formData = data;
      }else{
        this.formData={
          imgMobileArr:[],
          imgPcArr:[],
          jumpType:'1',
          isSycn:'1'
        }
      }
      this.visible = true;
      this.$nextTick(()=>{
        this.$refs.selectTreeRef&&this.$refs.selectTreeRef.init();
      })    
    },
    // 移动端图片上传
    imgUploadMobile() {
      if(this.formData.imgMobileArr && this.formData.imgMobileArr[0]){
        this.$set(this.formData,"mobilePic",this.formData.imgMobileArr[0].path)
      }
      this.$refs.form.validateField('mobilePic');
    },
    // pc端图片上传
    imgUploadPc(){
      if(this.formData.imgPcArr && this.formData.imgPcArr[0]){
        this.$set(this.formData,"pcPic",this.formData.imgPcArr[0].path)
      }
      this.$refs.form.validateField('pcPic')
    },
    // 切换调整类型
    changeJumpType(value) {
      if(value == '2'){
        this.formData.picTitle = '';
        this.formData.jumpUrl = '';
      }else{
        this.formData.picTitle = '';
        delete this.formData.productCode;
      }
    },
    // 选中产品
    getSelectProduct(data) {
      this.formData = {
        ...this.formData,
        productCode:data.productCode,
        picTitle:data.productName        
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.my-modal {
  /deep/ {
    .ivu-modal-body {
      padding-top: 0;
    }
  }
  .info-text {
    font-size: 12px;
    line-height: 1.5;
    padding-top: 5px;
    color: #ccc;
  }
  .product-title {
    margin-right: 15px;
    font-size: 12px;
  }
  .select-product-btn {
    height: 25px;
    line-height: 25px;
    margin-top: 2px;
  }
}
</style>